import request from '@/utils/request';

export function createFabricStockReport(params, selectedStockLocationIDs, fabricStatusOptionsSelected) {
  return request({
    method: 'post',
    params: params && params.query,
    data: {
      selectedStockLocationIDs: selectedStockLocationIDs,
      fabricStatusOptionsSelected: fabricStatusOptionsSelected
    },
    url: 'stock/fabric-stock-report'
  });
}

export const storeExtensions = {
  actions: {
    createStockReport({ dispatch }, { listParams, selectedStockLocationIDs, fabricStatusOptionsSelected }) {
      return new Promise((resolve, reject) =>
        createFabricStockReport(listParams, selectedStockLocationIDs, fabricStatusOptionsSelected)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};
